import Image from "../assets/Image.png";
import Star from "../assets/star.png";
import Vegan from '../assets/Vegan.svg';
//import WinterSalad from '../assets/food/recents/salad/winter-salad.png'
//import Strawberry from '../assets/food/recents/salad/strawberry-salad.png';
import Watermelon from '../assets/food/recents/salad/watermelon-salad.png'



const salad = [
  
  {
    id: 1,
    meal: "Watermelon & Arugula",
    image: Watermelon,
    vegan: "",
    star: Star,
    info:
      "Diced watermelon bits, thin sliced red onion, shredded parm on a bed of arugula, served with watermelon vinaigrette on the side."
  }
];

export default salad;
